// 路径信息
const pathStore = {
  namespaced: true,
  state: () => ({
    activeTab: 0,
    currentRouteMeta: {},
    path: ''
  }),
  // store 的计算属性
  getters: {
    getActiveTab(state) {
      return state.activeTab
    },
    getCurrentRouteMeta(state) {
      return state.currentRouteMeta
    },
    getCurrentRouterPath(state) {
      return state.path
    }
  },
  mutations: {
    setActiveTab(state, data) {
      state.activeTab = data
    },
    setCurrentRouteMeta(state, data) {
      state.currentRouteMeta = data
    },
    setCurrentRoutePath(state, data) {
      state.path = data
    }
  },
  actions: {
    setCurrentRouteMetaAction({commit}, data){
      commit('setCurrentRouteMeta', data)
    },
    setCurrentRoutePathAction({commit}, data){
      commit('setCurrentRoutePath', data)
    }
  }
}
export default pathStore
